import {
  PCCProgram,
} from 'dtos/pCCProgram';

export const PCC_ACTIVITY_TAB = 'activity';

export type PCCPanelTab = typeof PCC_ACTIVITY_TAB | PCCProgram;

/**
 * `month` is `YYYY-MM`. A missing `tab` means Activity.
 */
export type PCCPanelInfo = {
  patientId: number;
  month: string;
  tab?: PCCPanelTab;
};

export const PCC_MONTH_FORMAT = 'YYYY-MM';

const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

const PCC_TABS: readonly string[] = [PCC_ACTIVITY_TAB, ...Object.values(PCCProgram)];

export function parsePCCMonth(raw: string): string | null {
  return MONTH.test(raw) ? raw : null;
}

export function parsePCCTab(raw: string): PCCPanelTab | null {
  return PCC_TABS.includes(raw) ? raw as PCCPanelTab : null;
}

export function getPCCPanelIdentity({ patientId }: PCCPanelInfo) {
  return String(patientId);
}
